// Подгружает рекомендации к первому товару корзины и добавляет их без перезагрузки.
class CartUpsell extends HTMLElement {
  connectedCallback() {
    const productId = this.dataset.productId;
    if (!productId || this.dataset.loaded === 'true') return;
    this.dataset.loaded = 'true';

    const url = `${this.dataset.url}?section_id=cart-upsell&product_id=${productId}&intent=related&limit=6`;
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const inner = html.querySelector('.cart-upsell__inner');
        if (!inner) return;
        this.innerHTML = inner.outerHTML;
        this.hidden = false;
        this.bindForms();
      })
      .catch(() => {});
  }

  bindForms() {
    this.querySelectorAll('.cart-upsell__form').forEach((form) => {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const button = form.querySelector('button');
        button.setAttribute('disabled', 'disabled');
        button.classList.add('loading');

        const cartDrawer = document.querySelector('cart-drawer');
        const sections = cartDrawer
          ? ['cart-drawer', 'cart-icon-bubble']
          : ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble'];

        const body = new FormData(form);
        body.append('sections', sections.join(','));
        body.append('sections_url', window.location.pathname);

        fetch(`${window.routes.cart_add_url}`, {
          method: 'POST',
          headers: { Accept: 'application/javascript' },
          body,
        })
          .then((response) => response.json())
          .then((parsed) => {
            if (parsed.sections && cartDrawer) {
              cartDrawer.renderContents(parsed);
            } else {
              window.location.reload();
            }
          })
          .catch(() => window.location.reload());
      });
    });
  }
}

if (!customElements.get('cart-upsell')) customElements.define('cart-upsell', CartUpsell);
